export default (store) => ({
  path : 'users/:id(/:tab)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'userDetails' */
      './components/UserDetails'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
